var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{staticClass:"py-1 mx-auto mb-11",attrs:{"src":_vm.appLogo,"contain":"","max-width":"256","position":"center center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }